import React, { Component } from "react";
import AceEditor from "react-ace";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import "ace-builds/src-min-noconflict/ext-searchbox";
import "ace-builds/src-min-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/mode-jsx";
import axios from "axios";
import parse from "html-react-parser";
import { connect } from "react-redux";
import { LOGIN, LOGOUT } from "../../Pages/ReduxStore/slices/authSlice";
import { Redirect, Link as RouterLink } from "react-router-dom";

const languages = ["Java", "C", "C++", "Python"];

const themes = ["textmate", "tomorrow", "xcode", "monokai", "twilight"];

const modes = ["java", "c_cpp", "python"];

modes.forEach((lang) => {
  require(`ace-builds/src-noconflict/mode-${lang}`);
  require(`ace-builds/src-noconflict/snippets/${lang}`);
});

themes.forEach((theme) => require(`ace-builds/src-noconflict/theme-${theme}`));

const RenderDropdown = ({ attrList, attr, attrFunc, toggle, field, name }) => {
  return (
    <Dropdown isOpen={attrList} toggle={toggle}>
      <span className="field text-bold"> {name} : </span>
      <DropdownToggle
        color=""
        caret
        style={{ minwidth: "80px", textAlign: "left" }}
      >
        {attr}{" "}
      </DropdownToggle>
      <DropdownMenu
        modifiers={{
          setMaxHeight: {
            enabled: true,
            order: 890,
            fn: (data) => {
              return {
                ...data,
                styles: {
                  ...data.styles,
                  overflow: "auto",
                  maxHeight: "200px",
                },
              };
            },
          },
        }}
      >
        {field.map((option) => (
          <DropdownItem
            className="text-capitalize"
            key={option}
            value={option}
            onClick={attrFunc}
          >
            {option}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

const verdict = {
  201: '<span class="text-success"><span class="fa fa-check-circle"></span> AC : Accepted Correct Answer !!</span>',
  400: '<span class="text-danger"><span class="fa fa-times-circle"></span> WA : Wrong Answer !!</span>',
  408: '<span class=""><span class="fa fa-hourglass-end"></span> TLE : Time Limit Exceeded !!</span>',
  402: '<span class="text-danger">Runtime Error !!</span>',
  401: '<span class="text-danger">Compilation Error !!</span>',
};

let javaDefault, pythonDefault, cDefault, cppDefault, mapModeProps;
class EditorComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modeList: false,
      themeList: false,
      fontSizeList: false,
      mode: "java",
      language: "Java",
      value: this.defaultValue,
      placeholder: "/* Enter Your Code here */",
      theme: "textmate",
      enableBasicAutocompletion: true,
      enableLiveAutocompletion: true,
      fontSize: 14,
      showGutter: true,
      showPrintMargin: true,
      highlightActiveLine: true,
      enableSnippets: true,
      showLineNumbers: true,
      customInput: false,
      customInputValue: "",
      showOutput: false,
      problemOutput: {
        status: null,
        verdict: "",
      },
    };
    this.onChange = this.onChange.bind(this);
    this.setMode = this.setMode.bind(this);
    this.setTheme = this.setTheme.bind(this);
    this.setFontSize = this.setFontSize.bind(this);
    this.handleinputChange = this.handleinputChange.bind(this);

    // check localstorage for saved editor content
    javaDefault =
      localStorage.getItem(
        `${this.props.contestId.trim()}-${this.props.problemId.trim()}-java`
      ) === null
        ? `import java.io.*;
import java.util.*;

public class Main {

    public static void main(String[] args) {
        /* Enter your code here. Read input from STDIN. Print output to STDOUT.
        Your class should be named Main. */
    }
}`
        : localStorage.getItem(
            `${this.props.contestId.trim()}-${this.props.problemId.trim()}-java`
          );

    cDefault =
      localStorage.getItem(
        `${this.props.contestId.trim()}-${this.props.problemId.trim()}-clang`
      ) === null
        ? `#include <stdio.h>
#include <string.h>
#include <math.h>
#include <stdlib.h>

int main() {
    /* Enter your code here. Read input from STDIN. Print output to STDOUT */
    return 0;
}`
        : localStorage.getItem(
            `${this.props.contestId.trim()}-${this.props.problemId.trim()}-clang`
          );

    cppDefault =
      localStorage.getItem(
        `${this.props.contestId.trim()}-${this.props.problemId.trim()}-cpp`
      ) === null
        ? `#include <cmath>
#include <cstdio>
#include <vector>
#include <iostream>
#include <algorithm>
using namespace std;


int main() {
    /* Enter your code here. Read input from STDIN. Print output to STDOUT */
    return 0;
}`
        : localStorage.getItem(
            `${this.props.contestId.trim()}-${this.props.problemId.trim()}-cpp`
          );

    pythonDefault =
      localStorage.getItem(
        `${this.props.contestId.trim()}-${this.props.problemId.trim()}-python`
      ) === null
        ? `# Enter your code here. Read input from STDIN. Print output to STDOUT`
        : localStorage.getItem(
            `${this.props.contestId.trim()}-${this.props.problemId.trim()}-python`
          );

    mapModeProps = {
      Java: {
        mode: "java",
        value: javaDefault,
        post: "java",
      },
      C: {
        mode: "c_cpp",
        value: cDefault,
        post: "clang",
      },
      "C++": {
        mode: "c_cpp",
        value: cppDefault,
        post: "cpp",
      },
      Python: {
        mode: "python",
        value: pythonDefault,
        post: "python",
      },
    };
  }

  defaultValue = javaDefault;

  onChange = (newValue) => {
    this.setState({ value: newValue });

    // update localstorage with editor's content whenever it changes
    localStorage.setItem(
      `${this.props.contestId.trim()}-${this.props.problemId.trim()}-${
        mapModeProps[this.state.language].post
      }`,
      newValue
    );
  };
  setTheme(e) {
    this.setState({ themeList: !this.state.themeList, theme: e.target.value });
  }
  setFontSize(e) {
    this.setState({ fontSize: parseInt(e.target.value, 10) });
  }
  customInput = () => {
    this.setState({ showOutput: false, customInput: !this.state.customInput });
  };
  setMode(e) {
    this.setState({
      // before switching languages, check if the localstorage contains saved data
      // for the target language : if yes, then use it as the default value
      value:
        localStorage.getItem(
          `${this.props.contestId.trim()}-${this.props.problemId.trim()}-${
            mapModeProps[e.target.value].post
          }`
        ) === null
          ? mapModeProps[e.target.value].value
          : localStorage.getItem(
              `${this.props.contestId.trim()}-${this.props.problemId.trim()}-${
                mapModeProps[e.target.value].post
              }`
            ),
      modeList: !this.state.modeList,
      mode: mapModeProps[e.target.value].mode,
      language: e.target.value,
    });
  }
  handleinputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      customInputValue: value,
    });
    // console.log(this.state.customInputValue);
  }
  submitCode = () => {
    // console.log(this.state.value);
    this.setState({
      showOutput: true,
      problemOutput: {},
    });
    this.sendCode();
  };
  runCode = () => {
    // console.log(this.state.value);
    this.setState({
      showOutput: true,
      problemOutput: {},
    });
    this.sendCode();
  };
  sendCode = async () => {
    try {
      const res = await axios.post(
        `https://server.codeium.tech/` + this.props.problemId + "/submit",
        {
          username: this.props.username,
          code: this.state.value,
          lang: mapModeProps[this.state.language].post,
          contestId: this.props.contestId,
          problem_id: this.props.problemId,
          custom_input: this.state.customInput,
          input_testcase: this.state.customInputValue,
        }
      );
      if (res.data.status === 200) {
        this.setState({
          showOutput: true,
          problemOutput: res.data.msg,
        });
        // this.setState({ problemData: res.data.msg[0] });
        // console.log(this.state.fetchedData);
        // console.log(res);
      } else {
        // console.log(res);
      }
    } catch (err) {
      // console.log(err);
      // console.log("failed send");
      // console.log(this.state.problemData);
    }
  };
  render() {
    try {
      return (
        <div className="codeEditor">
          <div className="col-12 d-md-flex justify-content-md-center editor-settings py-2 px-md-4">
            <div className="col-12 col-md d-flex justify-content-md-center">
              <div className="">
                <RenderDropdown
                  attr={this.state.language}
                  attrList={this.state.modeList}
                  attrFunc={this.setMode}
                  field={languages}
                  name="Language"
                  toggle={() => {
                    this.setState({ modeList: !this.state.modeList });
                  }}
                />
              </div>
            </div>
            <div className="col-12 col-md d-flex justify-content-md-center">
              <div className="">
                <RenderDropdown
                  attr={this.state.theme}
                  attrList={this.state.themeList}
                  attrFunc={this.setTheme}
                  field={themes}
                  name="Theme"
                  toggle={() => {
                    this.setState({ themeList: !this.state.themeList });
                  }}
                />
              </div>
            </div>
            <div className="col-12 col-md d-flex justify-content-md-center">
              <div className="">
                <RenderDropdown
                  attr={this.state.fontSize}
                  attrList={this.state.fontSizeList}
                  attrFunc={this.setFontSize}
                  field={[14, 15, 16, 17, 18, 19, 20, 24, 28, 32, 40]}
                  name="FontSize"
                  toggle={() => {
                    this.setState({ fontSizeList: !this.state.fontSizeList });
                  }}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className=" d-flex col-12">
              <div
                className="d-flex justify-content-center"
                style={{
                  height: "100%",
                  width: "100%",
                  minHeight: "600px",
                  minWidth: "300px",
                }}
              >
                <AceEditor
                  placeholder={this.state.placeholder}
                  mode={this.state.mode}
                  theme={this.state.theme}
                  name="aceEditor"
                  onLoad={this.onLoad}
                  onChange={this.onChange}
                  onSelectionChange={this.onSelectionChange}
                  onCursorChange={this.onCursorChange}
                  onValidate={this.onValidate}
                  value={this.state.value}
                  fontSize={this.state.fontSize}
                  showPrintMargin={this.state.showPrintMargin}
                  showGutter={this.state.showGutter}
                  highlightActiveLine={this.state.highlightActiveLine}
                  height="100%"
                  width="100%"
                  enableSnippets="true"
                  editorProps={{ $blockScrolling: true }}
                  setOptions={{
                    useWorker: false,
                    enableBasicAutocompletion:
                      this.state.enableBasicAutocompletion,
                    enableLiveAutocompletion:
                      this.state.enableLiveAutocompletion,
                    enableSnippets: this.state.enableSnippets,
                    showLineNumbers: this.state.showLineNumbers,
                    tabSize: 4,
                  }}
                />
              </div>
            </div>
            <div className="col-12 d-flex justify-content-between mt-3">
              <div className="col d-flex">
                <div className="ml-3">
                  <input
                    type="checkbox"
                    id="customInput"
                    class="form-check-input"
                    name="customInput"
                    checked={this.state.customInput}
                    onChange={this.customInput}
                  />
                  <label htmlFor="customInput" class="form-check-label">
                    Test against custom input
                  </label>
                </div>
              </div>
              <div className="col d-flex justify-content-end">
                <button
                  className={
                    this.state.customInput
                      ? "btn btn-custom-dark py-2 px-4 run-code mx-2"
                      : "d-none"
                  }
                  // className="btn btn-custom-dark py-2 px-4 run-code mx-2"
                  onClick={this.runCode}
                >
                  Run Code
                </button>
                <button
                  onClick={this.submitCode}
                  className="btn btn-custom-dark py-2 px-4 submit-code ml-2"
                  disabled={this.state.customInput}
                >
                  Submit
                </button>
              </div>
            </div>
            <div class="col-12">
              <div className="col-6">
                <textarea
                  id="custom-input"
                  className={
                    this.state.customInput
                      ? "custom-input form-control"
                      : "custom-input form-control d-none"
                  }
                  value={this.state.customInputValue}
                  onChange={this.handleinputChange}
                ></textarea>
              </div>
            </div>
            <div class="col-12 my-5">
              <div
                className={this.state.showOutput ? "output" : "output d-none"}
              >
                <div className="p-3">
                  <h6>
                    <b>Output : </b>
                  </h6>
                  {this.state.customInput ? (
                    <div className="">
                      <span style={{ whiteSpace: "pre-line" }}>
                        {parse(
                          this.state.problemOutput.verdict || "Loading...."
                        )}
                      </span>
                    </div>
                  ) : (
                    <div className="">
                      <b>
                        {parse(
                          verdict[this.state.problemOutput.status] ||
                            "Loading...."
                        )}
                      </b>
                      {this.state.problemOutput.status === 401 ||
                      this.state.problemOutput.status === 402 ? (
                        <div className="">
                          <br />
                          <span>
                            Error Message Here{" "}
                            {this.state.problemOutput.verdict}
                          </span>
                        </div>
                      ) : (
                        <span></span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } catch {
      return <Redirect to="/404Page" />;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    username: state.auth.username,
    isAuthenticated: state.auth.isAuthenticated,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxLogin: (username) => dispatch(LOGIN(username)),
    reduxLogout: () => dispatch(LOGOUT()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditorComponent);

// JAVA
// import java.io.*;
// import java.util.*;

// public class Main {

//   public static void main(String[] args) {
//     /* Enter your code here. Read input from STDIN. Print output to STDOUT.
//     Your class should be named Main. */
//     Scanner scan = new Scanner(System.in);
//     int t = scan.nextInt();
//     while (t-- > 0) {
//       int a = scan.nextInt();
//       int b = scan.nextInt();
//       System.out.println(a + b);
//     }
//   }
// }

// PYTHON
// t = int(input())
// while (t) :
//   x, y = map(int, input().split())
// print(x + y)
// t = t - 1

// C
// #include <stdio.h>
// #include <string.h>
// #include <math.h>
// #include <stdlib.h>

//   int main() {
//   /* Enter your code here. Read input from STDIN. Print output to STDOUT */
//   int t;
//   scanf("%d",& t);
//   while (t-- > 0) {
//     int a, b;
//     scanf("%d %d",& a,& b);
//     printf("%d", (a + b));
//   }
//   return 0;
// }

// C++
// #include <cmath>
// #include <cstdio>
// #include <vector>
// #include <iostream>
// #include <algorithm>
// using namespace std;

// int main() {
//   int t;
//   std:: cin >> t;
//   while (t--) {
//     int a, b;
//     std:: cin >> a >> b;
//     std:: cout << a + b << std:: endl;
//   }
//   return 0;
// }
